// export const groupedInventories = (inventories: ProductInventoryDto[]): { [key: string]: ProductInventoryDto } => {
//     return inventories.reduce((acc: any, item: ProductInventoryDto) => {
//         const key = item.stock_variant;
//         if (!acc[key]) {
//             acc[key] = { ...item };
//         } else {
//             acc[key].stock += item.stock;
//         }
//         return acc;
//     }, {});
// }

export function formatPrice(price: number, separator?: boolean): string {
    // Separate the decimal part
    // Convert price to a string with two decimal places
    separator = separator ?? true;
    if (typeof price !== "number") {
        return `0${separator ? '.' : ','}00`;
    }

    const priceAmount = price.toFixed(2);

    // Split the string into integer and decimal parts
    const [integerPart, decimalPart] = priceAmount.split('.');

    // Format the integer part
    let formattedIntegerPart = integerPart;
    if (integerPart.length > 3 && integerPart.length < 7 && !integerPart.includes('-')) {
        formattedIntegerPart =
            integerPart.slice(0, integerPart.length - 3) + (separator ? '.' : ',') + integerPart.slice(-3);
    } else if (integerPart.length > 6 && !integerPart.includes('-')) {
        formattedIntegerPart =
            integerPart.slice(0, integerPart.length - 6) + (separator ? '.' : ',') + integerPart.slice(integerPart.length - 6, integerPart.length - 3) + (separator ? '.' : ',') + integerPart.slice(integerPart.length - 3, integerPart.length);
    }

    // Combine the formatted parts
    let formattedPrice = formattedIntegerPart;
    if (decimalPart) {
        formattedPrice += (separator ? ',' : '.') + decimalPart;
    }

    // if (!discount) {
    //   formattedPrice = formattedPrice.replace('.', ',');
    // }

    return `${formattedPrice}`;
}

// export function getPercentageDiscount(originalPrice: number, discountPrice: number): number {
//     if (discountPrice >= originalPrice) {
//         return 0;
//     }
//     return Math.ceil(100 * (originalPrice - discountPrice) / originalPrice);
// }

// export function getFiltersByCampaign(campaign: ProductCampaignDto): ProductsSearchDto | undefined {
//     let fixedFilters: ProductsSearchDto | undefined = {};
//     if (isCampaignBonattiComboDto(campaign)) {
//         fixedFilters = {
//             ids: campaign.items_1.concat(campaign.items_2).concat(campaign.items_3)
//         }
//     } else {
//         fixedFilters = campaign.items;
//     }
//     return fixedFilters;
// }

// export function zoomImage(event: React.MouseEvent, scale: number = 2, zoomOut?: boolean) {
//     let zoom = event.currentTarget as HTMLDivElement;
//     let clientX: number, clientY: number;
//     // event.offsetX ? clientX = event.offsetX : clientX = event.touches[0].pageX;
//     // event.offsetY ? clientY = event.offsetY : clientY = event.touches[0].pageY;
//     clientX = event.clientX;
//     clientY = event.clientY;
//     let x = (clientX - zoom.offsetWidth) / zoom.offsetWidth;
//     let y = (clientY - zoom.offsetHeight * 0.22) / zoom.offsetHeight;

//     zoom.style.cursor = 'zoom-in';
//     zoom.style.transition = `all ${zoomOut ? 0.2 : 0.1}s linear`;
//     zoom.parentElement ? zoom.parentElement.style.overflow = 'hidden' : '';
//     zoom.style.transformOrigin = `${x * 100}% ${y * 100}% 0px`;
//     zoom.style.transform = zoomOut ? `scale(1)` : `scale(${scale})`;
// }

// export default groupedInventories;


export function getGroupCodes(items: any[]): string[]{
  let groupCodes = items.map(item => item.group_code);
  let uniqueCodes = new Set(groupCodes);
  return Array.from(uniqueCodes);
}

// export const getDiscountByCampaigns = (tariff: CatalogProductDto): number => {
//   let price = tariff.base_price;
//   let campaign = tariff.available_campaigns[0];

//   // if (ProductCampaignTemplates.CAMPAIGN_CONTRACT_BINDING === campaign.template) {
//       switch (campaign.discount_type) {
//           case DiscountTypes.DISCOUNT_TYPE_AMOUNT:
//               price = price > (campaign.discount_amount ?? 0) ? (price - campaign.discount_amount) : price;
//               break;
//           case DiscountTypes.DISCOUNT_TYPE_PERCENTAGE:
//               price = (campaign.discount_percentage ?? 0) > 0 ? (price - (campaign.discount_percentage * price / 100)) : price;
//               break;
//           default:
//               price;
//               break;
//       }
//   // }

//   return +price.toFixed(2);
// }